import Middlewares from '@/middlewares';

export default [{
        path: '*',
        meta: {
            otherLayout: true
        },
        redirect: {
            path: '/404'
        }
    },
    {
        path: '/404',
        meta: {
            otherLayout: true
        },
        name: 'NotFound',
        component: () => import('@/views/errors/NotFound.vue')
    },
    {
        path: '/',
        meta: {
            otherLayout: true
        },
        redirect: {
            name: 'login'
        }
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            middleware: [Middlewares.guest],
            otherLayout: true
        },
        component: () => import('@/views/auth/Login.vue'),
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            otherLayout: true
        },
        component: () => import('@/views/auth/Register.vue'),
    },
    {
        path: '/simple-page',
        name: 'simple-page',
        component: () => import('@/views/SimplePage.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'Simple Page',
            subTitle: 'Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit',
            otherLayout: false
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
            middleware: [Middlewares.auth],
            otherLayout: false,
            manualLayout: true
        }
    },
    {
        path: '/system-list',
        name: 'index',
        component: () => import('@/views/SystemList.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'SYSTEM LIST',
            cardTitle: ' ',
            otherLayout: false,
            manualLayout: true
        }
    },
    {
        path: '/sms-gateway/sms',
        name: 'sms-gateway.sms',
        component: () => import('@/views/sms-gateway/SendSMS.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'SMS GATEWAY',
            cardTitle: 'SEND SMS',
            otherLayout: false,
        }
    },
    {
        path: '/sms-gateway/sms-log',
        name: 'sms-gateway.sms-log',
        component: () => import('@/views/sms-gateway/SMSLog.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'SMS GATEWAY',
            cardTitle: 'SMS LOG',
            otherLayout: false,
        }
    },
    {
        path: '/slip-ok/slip',
        name: 'slip-ok.slip',
        component: () => import('@/views/slip-ok/CheckSlip.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'SLIP OK',
            cardTitle: 'CHECK SLIP',
            otherLayout: false,
        }
    },
    {
        path: '/slip-ok/slip-log',
        name: 'slip-ok.slip-log',
        component: () => import('@/views/slip-ok/SlipLog.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'SLIP OK',
            cardTitle: 'SLIP LOG',
            otherLayout: false,
        }
    },
    {
        path: '/flash-express/order',
        name: 'flash-express.order',
        component: () => import('@/views/flash-express/FlashOrder.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'FLASH ORDER',
            cardTitle: 'Flash Order',
            cardSubTitle: 'Data table of flash orders.',
            otherLayout: false,
        }
    },
    {
        path: '/flash-express/profile',
        name: 'flash-express.profile',
        component: () => import('@/views/flash-express/FlashProfile.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'FLASH PROFILE',
            cardTitle: 'Profile',
            cardSubTitle: 'Data table of flash user profile.',
            otherLayout: false,
        }
    },
    {
        path: '/license-control/customer-list/:search/:filter_exp/:filter_exp_select/:filter_exp_option/:filter_exp_specify_input/:customer',
        name: 'license-control.customer-list',
        component: () => import('@/views/license-control/CustomerList.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'LICENSE CONTROL',
            subTitle: 'License Control management.',
            cardTitle: 'CUSTOMER LIST',
            cardSubTitle: 'Data table of customer lists.',
            otherLayout: false
        }
    },
    {
        path: '/license-control/domain-type',
        name: 'license-control.domain-type',
        component: () => import('@/views/license-control/DomainType.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'LICENSE CONTROL',
            subTitle: 'License Control management.',
            cardTitle: 'DOMAIN TYPE',
            cardSubTitle: 'Data table of domain types.',
            otherLayout: false
        }
    },
    {
        path: '/license-control/product-list',
        name: 'license-control.product-list',
        component: () => import('@/views/license-control/ProductList.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'LICENSE CONTROL',
            subTitle: 'License Control management.',
            cardTitle: 'PRODUCT LIST',
            cardSubTitle: 'Data table of product lists.',
            otherLayout: false
        }
    },
    {
        path: '/license-control/server-list',
        name: 'license-control.server-list',
        component: () => import('@/views/license-control/ServerList.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'LICENSE CONTROL',
            subTitle: 'License Control management.',
            cardTitle: 'SERVER LIST',
            cardSubTitle: 'Data table of server lists.',
            otherLayout: false
        }
    },
    {
        path: '/sync-upload',
        name: 'sync-upload',
        component: () => import('@/views/SyncUpload.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'Sync Upload',
            cardTitle: 'Sync Upload Control management.',
            cardSubTitle: 'Data table of sync upload.',
            otherLayout: false,
        }
    },
    {
        path: '/ticket/:ticket',
        name: 'ticket',
        component: () => import('@/views/Issue.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'TICKET',
            cardTitle: 'Ticket Control management.',
            cardSubTitle: 'Data table of ticket.',
            otherLayout: false,
        }
    },
    {
        path: '/date_calculator',
        name: 'date_calculator',
        component: () => import('@/views/DateCalculator.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'Date Calculator',
            cardTitle: 'Date Calculator',
            cardSubTitle: 'A date calculator lets you make various kinds of date calculations.',
            otherLayout: false,
        }
    },
    {
        path: '/note',
        name: 'note',
        component: () => import('@/views/Note.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'NOTE',
            cardTitle: 'Note Control management.',
            cardSubTitle: 'Data table of note.',
            otherLayout: false,
        }
    },
    {
        path: '/download',
        name: 'download',
        component: () => import('@/views/Download.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'DOWNLOAD',
            cardTitle: 'Download Control management.',
            cardSubTitle: 'Data table of downloads.',
            otherLayout: false,
        }
    },
    {
        path: '/permission',
        name: 'permission',
        component: () => import('@/views/Permission.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'PERMISSION',
            cardTitle: 'Permisson Control management.',
            cardSubTitle: 'Data table of users.',
            otherLayout: false,
        }
    },
    {
        path: '/settings/system-list',
        name: 'settings.system-list',
        component: () => import('@/views/settings/SystemList.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'SYSTEM LIST',
            subTitle: 'Setting Control management.',
            cardTitle: 'SYSTEM LIST',
            cardSubTitle: 'Data table of system lists.',
            otherLayout: false
        }
    },
    {
        path: '/project/cesstant-cloud/redirect',
        name: 'redirect.cesstant-cloud',
        component: () => import('@/views/project/cesstant-cloud/Redirect.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'REDIRECT',
            cardTitle: 'CESSTANT CLOUD',
            cardSubTitle: 'Data table of redirect.',
            otherLayout: false,
        }
    },
    {
        path: '/project/cesstant-cloud/document',
        name: 'document.cesstant-cloud',
        component: () => import('@/views/project/cesstant-cloud/Document.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'DOCUMENT',
            cardTitle: 'CESSTANT CLOUD',
            cardSubTitle: 'Document title of Cesstant Cloud.',
            otherLayout: false,
        }
    },
    {
        path: '/project/cesstant-cloud/notify',
        name: 'notify.cesstant-cloud',
        component: () => import('@/views/project/cesstant-cloud/Notify.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'NOTIFY',
            cardTitle: 'CESSTANT CLOUD',
            cardSubTitle: 'Data table of notifies.',
            otherLayout: false,
        }
    },
    {
        path: '/project/cesstant-cloud/policy',
        name: 'policy.cesstant-cloud',
        component: () => import('@/views/project/cesstant-cloud/Policy.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'POLICY',
            cardTitle: 'CESSTANT CLOUD',
            cardSubTitle: 'Data table of policies.',
            otherLayout: false,
        }
    },
    {
        path: '/project/cesstant-cloud/translate',
        name: 'translate.cesstant-cloud',
        component: () => import('@/views/project/cesstant-cloud/Translate.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'TRANSLATE',
            cardTitle: 'CESSTANT CLOUD',
            cardSubTitle: 'Data table of translate.',
            otherLayout: false,
        }
    },
    {
        path: '/project/multibrand/document',
        name: 'document.multibrand',
        component: () => import('@/views/project/multibrand/Document.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'DOCUMENT',
            cardTitle: 'MULTI STORE',
            cardSubTitle: 'Document title of Multi Store.',
            otherLayout: false,
        }
    },
    {
        path: '/project/multibrand/redirect',
        name: 'redirect.multibrand',
        component: () => import('@/views/project/multibrand/Redirect.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'REDIRECT',
            cardTitle: 'MULTI STORE',
            cardSubTitle: 'Data table of redirect.',
            otherLayout: false,
        }
    },
    {
        path: '/project/multibrand/translate',
        name: 'translate.multibrand',
        component: () => import('@/views/project/multibrand/Translate.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'TRANSLATE',
            cardTitle: 'MULTI STORE',
            cardSubTitle: 'Data table of translate.',
            otherLayout: false,
        }
    },
    {
        path: '/project/web-management/document',
        name: 'document.web-management',
        component: () => import('@/views/project/web-management/Document.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'DOCUMENT',
            cardTitle: 'WEB MANAGEMENT',
            cardSubTitle: 'Document title of Web Management.',
            otherLayout: false,
        }
    },
    {
        path: '/project/web-management/notify',
        name: 'notify.web-management',
        component: () => import('@/views/project/web-management/Notify.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'NOTIFY',
            cardTitle: 'WEB MANAGEMENT',
            cardSubTitle: 'Data table of notifies.',
            otherLayout: false,
        }
    },
    {
        path: '/project/web-management/policy',
        name: 'policy.web-management',
        component: () => import('@/views/project/web-management/Policy.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'POLICY',
            cardTitle: 'WEB MANAGEMENT',
            cardSubTitle: 'Data table of policies.',
            otherLayout: false,
        }
    },
    {
        path: '/project/web-management/redirect',
        name: 'redirect.web-management',
        component: () => import('@/views/project/web-management/Redirect.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'REDIRECT',
            cardTitle: 'WEB MANAGEMENT',
            cardSubTitle: 'Data table of redirect.',
            otherLayout: false,
        }
    },
    {
        path: '/project/other/redirect',
        name: 'redirect.other',
        component: () => import('@/views/project/other/Redirect.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'REDIRECT',
            cardTitle: 'OTHER',
            cardSubTitle: 'Data table of Other.',
            otherLayout: false,
        }
    },
    {
        path: '/project/other/document',
        name: 'document.other',
        component: () => import('@/views/project/other/Document.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'DOCUMENT',
            cardTitle: 'OTHER',
            cardSubTitle: 'Document title of Other.',
            otherLayout: false,
        }
    },
    {
        path: '/central/line-api-register',
        name: 'central.line-api-register',
        meta: {
            otherLayout: true
        },
        component: () => import('@/views/central/LineApiRegister.vue'),
    },
    {
        path: '/translate/dashboard',
        name: 'translate.dashboard',
        component: () => import('@/views/scope/translate/Dashboard.vue'),
        meta: {
            middleware: [Middlewares.auth],
            otherLayout: false,
            manualLayout: true
        }
    },
    {
        path: '/translate/jobs/:project_list_id',
        name: 'translate.jobs',
        component: () => import('@/views/scope/translate/Job.vue'),
        meta: {
            middleware: [Middlewares.auth],
            title: 'TRANSLATE',
            cardTitle: '',
            cardSubTitle: '',
            otherLayout: false,
        }
    },
];
